export const translations = {
  es: {
    nav: {
      products: "Productos",
      services: "Servicios",
      about: "Nosotros",
      faq: "FAQ",
      contact: "Contacto",
      cta: "Cotizar",
    },
    hero: {
      overline: "// AI · SOFTWARE · DESARROLLO",
      title_1: "Ingeniería de software",
      title_2: "con inteligencia real.",
      subtitle:
        "Rio Code construye sistemas inteligentes, plataformas de facturación y soluciones de IA a medida. Escala tu operación con desarrolladores de élite.",
      cta_primary: "Iniciar proyecto",
      cta_secondary: "Ver productos",
      stat_1: "Proyectos entregados",
      stat_2: "Uptime promedio",
      stat_3: "Países atendidos",
    },
    products: {
      overline: "// CATÁLOGO",
      title: "Software que trabaja por ti.",
      description:
        "Productos empaquetados listos para desplegar. Personalizables, seguros y escalables desde el día uno.",
      items: [
        {
          tag: "BILLING SYSTEMS",
          title: "Sistema Facturación Rio Code",
          description:
            "Plataforma todo en uno que centraliza facturación, bases de datos y automatización de correos. Combina flujos visuales y cobros adaptados a la realidad fiscal de la región.",
          bullets: ["Facturación electrónica", "Automatización visual", "Multiplataforma"],
          cta: "Ver demo",
          url: "https://demo.rio-code.com",
        },
      ],
    },
    services: {
      overline: "// SERVICIOS",
      title: "Desarrollo bajo demanda.",
      description:
        "Somos tu equipo técnico externo. Desde el prototipo hasta el sistema en producción.",
      items: [
        {
          title: "Nuevos proyectos",
          desc: "Diseñamos, arquitectamos y construimos desde cero: web, móvil, backend y IA.",
        },
        {
          title: "Ajustes y modificaciones",
          desc: "Auditoría, refactor y expansión de sistemas legados con cero downtime.",
        },
        {
          title: "Integración de IA",
          desc: "Chatbots, agentes autónomos, RAG y pipelines de datos productivos.",
        },
        {
          title: "Consultoría técnica",
          desc: "Arquitectura, DevOps, seguridad y escalabilidad para equipos técnicos.",
        },
      ],
    },
    about: {
      overline: "// NOSOTROS",
      title: "Un equipo, dos disciplinas: código e inteligencia.",
      description:
        "Rio Code combina ingeniería de software rigurosa con inteligencia artificial aplicada. Trabajamos con startups, PYMEs y corporativos.",
      value_1: {
        title: "Precisión",
        desc: "Código auditable, documentado y probado. Sin deuda técnica oculta.",
      },
      value_2: {
        title: "Velocidad",
        desc: "Sprints cortos, entregas semanales, visibilidad total.",
      },
      value_3: {
        title: "Escala",
        desc: "Arquitecturas que soportan de 100 a 1 millón de usuarios.",
      },
    },
    faq: {
      overline: "// PREGUNTAS FRECUENTES",
      title: "Todo lo que quieres saber.",
      items: [
        {
          q: "¿Cuánto tarda un proyecto?",
          a: "Un MVP típico: 4 a 8 semanas. Proyectos complejos: 3 a 6 meses. Damos estimaciones exactas tras el discovery inicial.",
        },
        {
          q: "¿Trabajan con equipos internos?",
          a: "Sí. Nos integramos como equipo aumentado o asumimos el liderazgo técnico completo.",
        },
        {
          q: "¿Qué stack manejan?",
          a: "React/Next.js, FastAPI/Node, MongoDB/Postgres, LLMs (Claude, GPT, Gemini), AWS/GCP.",
        },
        {
          q: "¿Cómo son los costos?",
          a: "Modelos por proyecto cerrado, por sprint o retainer mensual. Sin costos ocultos.",
        },
      ],
    },
    contact: {
      overline: "// CONTACTO",
      title: "Escríbenos.",
      description:
        "Cuéntanos tu idea. Respondemos en menos de 24 horas hábiles.",
      name: "Nombre completo",
      email: "Email",
      company: "Empresa (opcional)",
      service: "Servicio de interés",
      service_options: [
        "Software inteligente",
        "Sistema de facturación",
        "Sistema de IA",
        "Nuevo proyecto",
        "Ajustes / Modificaciones",
        "Consultoría",
      ],
      message: "Cuéntanos tu proyecto",
      submit: "Enviar mensaje",
      submitting: "Enviando...",
      success: "Mensaje enviado. Te contactaremos pronto.",
      error: "Ocurrió un error. Intenta de nuevo.",
    },
    footer: {
      tagline: "Ingeniería y IA a medida.",
      rights: "Todos los derechos reservados.",
    },
    chat: {
      title: "RIO · Asistente IA",
      powered: "Impulsado por Claude Sonnet 4.5",
      placeholder: "Escribe tu pregunta...",
      welcome:
        "Hola, soy RIO. ¿En qué proyecto puedo ayudarte hoy? Software inteligente, facturación, IA o desarrollo a medida.",
      send: "Enviar",
    },
  },
  en: {
    nav: {
      products: "Products",
      services: "Services",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      cta: "Get a quote",
    },
    hero: {
      overline: "// AI · SOFTWARE · DEVELOPMENT",
      title_1: "Software engineering",
      title_2: "with real intelligence.",
      subtitle:
        "Rio Code builds intelligent systems, billing platforms, and AI solutions on demand. Scale your operation with an elite dev team.",
      cta_primary: "Start a project",
      cta_secondary: "See products",
      stat_1: "Projects shipped",
      stat_2: "Average uptime",
      stat_3: "Countries served",
    },
    products: {
      overline: "// CATALOG",
      title: "Software that works for you.",
      description:
        "Packaged products ready to deploy. Customizable, secure, and scalable from day one.",
      items: [
        {
          tag: "BILLING SYSTEMS",
          title: "Rio Code Billing System",
          description:
            "All-in-one platform centralizing billing, databases, and email automation. Combines visual workflows and collections tailored to the region's fiscal reality.",
          bullets: ["E-invoicing", "Visual automation", "Multi-platform"],
          cta: "View demo",
          url: "https://demo.rio-code.com",
        },
      ],
    },
    services: {
      overline: "// SERVICES",
      title: "On-demand development.",
      description:
        "We are your external technical team. From prototype to production.",
      items: [
        {
          title: "New projects",
          desc: "We design, architect, and build from scratch: web, mobile, backend, and AI.",
        },
        {
          title: "Adjustments & modifications",
          desc: "Audit, refactor, and expand legacy systems with zero downtime.",
        },
        {
          title: "AI integration",
          desc: "Chatbots, autonomous agents, RAG, and production-grade data pipelines.",
        },
        {
          title: "Technical consulting",
          desc: "Architecture, DevOps, security, and scalability for tech teams.",
        },
      ],
    },
    about: {
      overline: "// ABOUT",
      title: "One team, two disciplines: code and intelligence.",
      description:
        "Rio Code combines rigorous software engineering with applied artificial intelligence. We work with startups, SMBs, and enterprises.",
      value_1: {
        title: "Precision",
        desc: "Auditable, documented, and tested code. No hidden technical debt.",
      },
      value_2: {
        title: "Speed",
        desc: "Short sprints, weekly deliveries, full visibility.",
      },
      value_3: {
        title: "Scale",
        desc: "Architectures that scale from 100 to 1M users.",
      },
    },
    faq: {
      overline: "// FAQ",
      title: "Everything you want to know.",
      items: [
        {
          q: "How long does a project take?",
          a: "Typical MVP: 4 to 8 weeks. Complex projects: 3 to 6 months. Exact estimates after initial discovery.",
        },
        {
          q: "Do you work with internal teams?",
          a: "Yes. We integrate as an augmented team or take full technical leadership.",
        },
        {
          q: "What stack do you use?",
          a: "React/Next.js, FastAPI/Node, MongoDB/Postgres, LLMs (Claude, GPT, Gemini), AWS/GCP.",
        },
        {
          q: "How does pricing work?",
          a: "Fixed-price projects, per-sprint, or monthly retainer. No hidden costs.",
        },
      ],
    },
    contact: {
      overline: "// CONTACT",
      title: "Write to us.",
      description:
        "Tell us your idea. We reply within 24 business hours.",
      name: "Full name",
      email: "Email",
      company: "Company (optional)",
      service: "Service of interest",
      service_options: [
        "Smart software",
        "Billing system",
        "AI system",
        "New project",
        "Adjustments / Modifications",
        "Consulting",
      ],
      message: "Tell us about your project",
      submit: "Send message",
      submitting: "Sending...",
      success: "Message sent. We'll reach out soon.",
      error: "Something went wrong. Try again.",
    },
    footer: {
      tagline: "Custom engineering and AI.",
      rights: "All rights reserved.",
    },
    chat: {
      title: "RIO · AI Assistant",
      powered: "Powered by Claude Sonnet 4.5",
      placeholder: "Type your question...",
      welcome:
        "Hi, I'm RIO. What project can I help you with today? Smart software, billing, AI, or custom development.",
      send: "Send",
    },
  },
};

export const WHATSAPP_NUMBER = "5804120389197"; // Replace with real number
export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/riocode",
  instagram: "https://instagram.com/riocode",
  twitter: "https://twitter.com/riocode",
  linkedin: "https://linkedin.com/company/riocode",
  youtube: "https://youtube.com/@riocode",
  tiktok: "https://tiktok.com/@riocode",
  whatsapp: `https://wa.me/5804120389197`,
};
